export const aiDigitalData = {
  // ページ内ナビゲーション
  navItems: [
    { label: "サービス概要", anchor: "#overview" },
    { label: "導入支援", anchor: "#implementation-support" },
    { label: "進め方", anchor: "#implementation-flow" },
    { label: "対応範囲", anchor: "#scope" },
    { label: "料金", anchor: "#pricing" },
    { label: "よくある質問", anchor: "#faq" },
  ],

  // 1. ファーストビュー
  hero: {
    breadcrumbs: [
      { label: "ホーム", href: "/" },
      { label: "サービス", href: null },
      { label: "AI・デジタル導入支援", href: null },
    ],
    serviceLabel: "SERVICE 03",
    serviceSubLabel: "AI & DIGITAL IMPLEMENTATION",
    mainCopy: "何を導入するかより、\n何を改善したいかから考える",
    description:
      "生成AI、Google Workspace、各種クラウドツールの選定から、初期設定、利用ルール、研修、試行運用まで支援します。現在の業務に合わせて、無理なく使い始められる環境を整えます。",
    tags: [
      { label: "中小企業・地域団体向け", icon: "ri-building-2-line" },
      { label: "スポット・プロジェクト型", icon: "ri-focus-3-line" },
      { label: "初期設定・研修対応", icon: "ri-settings-3-line" },
      { label: "オンライン・訪問対応", icon: "ri-global-line" },
    ],
    image:
      "https://readdy.ai/api/search-image?query=Warm%20abstract%20organic%20background%20with%20soft%20flowing%20layered%20shapes%20in%20cream%20beige%20and%20warm%20neutral%20tones%2C%20subtle%20paper%20texture%2C%20gentle%20curved%20geometric%20forms%2C%20floating%20document%20icons%2C%20folder%20outlines%2C%20gear%20and%20checklist%20symbols%20integrated%20into%20abstract%20composition%2C%20minimal%20artistic%20design%2C%20warm%20orange%20amber%20accents%2C%20no%20people%20no%20faces%2C%20Japanese%20editorial%20abstract%20suitable%20for%20hero%20section%2C%20calm%20professional%20atmosphere%20with%20gentle%20gradient%20of%20warm%20light%20tones&width=1920&height=1080&seq=ai-digital-hero-bg&orientation=landscape",
  },

  // 3. サービス概要
  serviceOverview: {
    label: "SERVICE OVERVIEW",
    title: "AI・デジタル導入支援 サービス概要",
    description:
      "このページを最後まで読まなくても、このサービスの基本的な仕組みがわかります。",
    items: [
      { label: "対象", value: "AIやデジタルツールを導入したい中小企業、団体、事務局" },
      { label: "契約形態", value: "スポット・プロジェクト契約" },
      { label: "支援期間", value: "内容に応じて設定" },
      { label: "対応領域", value: "生成AI、Google Workspace、情報共有、業務整理、クラウドツール" },
      { label: "支援内容", value: "課題整理、選定、初期設定、ルール作成、研修、試行運用" },
      { label: "訪問対応", value: "都内近郊を中心に対応" },
      { label: "継続支援", value: "必要に応じてDX顧問・事務局サポートへ移行可能" },
      { label: "制作・開発", value: "独自開発が必要な場合は別途お見積り" },
    ],
  },

  // 4. お悩み
  challenges: {
    label: "CHALLENGES",
    title: "AIやデジタルを導入したいと思いながら、止まっていませんか",
    items: [
      {
        icon: "ri-question-line",
        title: "何から始めるべきか分からない",
        desc: "AIやデジタルの情報は多いが、自社に何が必要なのか判断できない。",
      },
      {
        icon: "ri-file-list-2-line",
        title: "ツールの違いが分からない",
        desc: "似たサービスが多く、料金や機能を比較しても選びきれない。",
      },
      {
        icon: "ri-user-unfollow-line",
        title: "導入しても使われるか不安",
        desc: "新しいツールを契約しても、担当者以外が使わなくなる可能性がある。",
      },
      {
        icon: "ri-shield-keyhole-line",
        title: "情報管理や安全性が心配",
        desc: "AIへ入力してよい情報や、ファイル共有のルールが決まっていない。",
      },
      {
        icon: "ri-user-settings-line",
        title: "初期設定を任せられる人がいない",
        desc: "アカウント、権限、共有フォルダなどを誰が整えるか決まっていない。",
      },
      {
        icon: "ri-chat-smile-2-line",
        title: "社員や担当者への説明が難しい",
        desc: "導入の目的や使い方を、社内や団体内でうまく説明できない。",
      },
    ],
  },

  // 5. AI・デジタル導入支援とは
  about: {
    label: "ABOUT THE SERVICE",
    title: "ツールを決める前に、現在の仕事を整理します",
    description:
      "AI・デジタル導入支援は、特定の製品やサービスを販売するための支援ではありません。",
    description2:
      "まず、現在どのような業務があり、どこに時間がかかり、何を改善したいのかを確認します。",
    description3:
      "そのうえで、現在の人員、予算、利用環境に合うツールを選び、初期設定、利用ルール、テンプレート、操作説明まで整えます。",
    toolFirst: {
      title: "ツール導入が先の場合",
      steps: ["製品を決める", "契約する", "設定する", "使い方は現場に任せる"],
    },
    nobleWay: {
      title: "ノーブルラボの導入支援",
      steps: [
        "業務と課題を確認する",
        "改善したい内容を決める",
        "必要なツールを選ぶ",
        "設定・ルール・研修を整える",
        "実際の業務で試す",
      ],
    },
  },

  // 6. 主な導入支援
  implementationSupport: {
    label: "IMPLEMENTATION SUPPORT",
    title: "組織の課題に合わせたご提案",
    categories: [
      {
        num: "01",
        title: "生成AI導入支援",
        tools: "Gemini、ChatGPT、Microsoft Copilot、その他の生成AIサービス",
        supports: [
          "利用目的の整理",
          "サービスやプランの選定",
          "アカウント・利用環境の確認",
          "AIへ入力してよい情報の整理",
          "社内・団体内の利用ルール作成",
          "業務別プロンプト・テンプレート作成",
          "基本操作と活用方法の説明",
        ],
      },
      {
        num: "02",
        title: "Google Workspace導入支援",
        tools: "",
        supports: [
          "利用プランの検討",
          "アカウント構成の整理",
          "メール・カレンダーの設定",
          "Google Driveの共有方法",
          "共有ドライブ・フォルダ構成",
          "権限の整理",
          "Googleフォームの活用",
          "基本操作の説明",
        ],
      },
      {
        num: "03",
        title: "情報共有・業務整理",
        tools: "",
        supports: [
          "ファイルやデータの保存場所の整理",
          "業務フローの確認",
          "Excelやスプレッドシートの整理",
          "会議・申込・問い合わせ業務の見直し",
          "テンプレート作成",
          "アカウントや権限の整理",
          "引き継ぎ方法の整備",
        ],
      },
      {
        num: "04",
        title: "研修・利用ルール整備",
        tools: "",
        supports: [
          "経営者・担当者向け説明",
          "社員・メンバー向け基本研修",
          "AIやクラウド利用時の注意点",
          "個人情報・機密情報の扱い",
          "業務別の使い方",
          "操作手順書",
          "よくある質問の整理",
        ],
      },
    ],
  },

  // 7. 導入までの進め方
  implementationFlow: {
    label: "IMPLEMENTATION FLOW",
    title: "課題を確認し、小さく試してから本格導入へ",
    steps: [
      {
        num: "01",
        title: "ヒアリング",
        desc: "現在の業務、困りごと、利用ツール、担当者、予算を確認します。",
      },
      {
        num: "02",
        title: "課題整理・導入方針",
        desc: "何を改善するのか、どの業務から始めるのかを整理します。",
      },
      {
        num: "03",
        title: "ツール選定・設計",
        desc: "機能、費用、安全性、運用負担を比較し、導入する仕組みを決めます。",
      },
      {
        num: "04",
        title: "初期設定・ルール整備",
        desc: "アカウント、権限、共有環境、利用ルール、テンプレートを整えます。",
      },
      {
        num: "05",
        title: "説明・試行運用",
        desc: "実際の業務で使い、分かりにくい部分や運用上の課題を修正します。",
      },
    ],
    centerText: "整理 → 選定 → 設定 → 試す → 使い始める",
  },

  // 8. 最初の1〜2か月の支援イメージ
  implementationSchedule: {
    label: "IMPLEMENTATION SCHEDULE",
    title: "導入内容に応じて、1〜2か月程度を目安に進めます",
    phases: [
      {
        name: "前半",
        label: "現状整理と設計",
        tasks: [
          "業務ヒアリング",
          "利用中のサービス確認",
          "改善対象の決定",
          "ツール比較・選定",
          "導入計画の作成",
        ],
        deliverables: "課題一覧・導入方針・利用ツール一覧",
      },
      {
        name: "中盤",
        label: "設定とルール整備",
        tasks: [
          "アカウント設定",
          "権限整理",
          "フォルダ構成",
          "AI利用ルール",
          "テンプレート作成",
          "手順書作成",
        ],
        deliverables: "利用環境・運用ルール・テンプレート",
      },
      {
        name: "後半",
        label: "研修と試行運用",
        tasks: [
          "操作説明",
          "実際の業務で利用",
          "質問・課題の確認",
          "設定やルールの修正",
          "今後の運用方法の整理",
        ],
        deliverables: "操作資料・試行結果・今後の改善事項",
      },
    ],
    note: "支援期間は、対象となる業務、利用人数、設定内容によって異なります。",
  },

  // 9. 導入後に残るもの
  deliverables: {
    label: "DELIVERABLES",
    title: "使い続けるためのルールと記録を残します",
    items: [
      { icon: "ri-file-list-3-line", text: "課題一覧・導入方針" },
      { icon: "ri-computer-line", text: "利用サービス・アカウント一覧" },
      { icon: "ri-shield-user-line", text: "権限と管理者の整理" },
      { icon: "ri-folder-shared-line", text: "共有フォルダ構成" },
      { icon: "ri-file-shield-line", text: "AI・デジタル利用ルール" },
      { icon: "ri-file-copy-line", text: "業務別テンプレート" },
      { icon: "ri-book-open-line", text: "操作手順書" },
      { icon: "ri-presentation-line", text: "研修資料" },
      { icon: "ri-chat-check-line", text: "試行運用時の質問・改善記録" },
      { icon: "ri-todo-line", text: "今後取り組む課題一覧" },
    ],
  },

  // 10. 具体的な相談例
  examples: {
    label: "SUPPORT EXAMPLES",
    title: "このような導入相談に対応します",
    items: [
      "生成AIを社内で使いたいが、どのサービスがよいか分からない",
      "Geminiを導入したが、業務での使い方を整理したい",
      "Google Workspaceへ移行したい",
      "Google Driveの共有方法を見直したい",
      "AIへ個人情報を入力しないためのルールをつくりたい",
      "会議資料や議事録作成にAIを使いたい",
      "社員向けに生成AIの研修を行いたい",
      "複数のExcelやスプレッドシートを整理したい",
      "紙やメールで行っている申込受付を改善したい",
      "新しいツールを契約する前に、本当に必要か相談したい",
    ],
  },

  // 11. 対応範囲と別途費用
  scope: {
    label: "SCOPE",
    title: "導入に必要な整理・設定・説明を支援します",
    note: "別途費用が必要な場合は、作業を始める前に内容と費用をご説明します。",
    included: {
      title: "導入支援に含まれる主な内容",
      items: [
        "現状と課題のヒアリング",
        "導入方針の整理",
        "ツール比較・選定支援",
        "基本的な初期設定",
        "権限や共有方法の整理",
        "利用ルール作成",
        "テンプレート作成",
        "基本操作の説明",
        "試行運用時の確認",
      ],
    },
    excluded: {
      title: "原則として別途費用になるもの",
      items: [
        "大量のデータ入力・データ移行",
        "多数のアカウント設定",
        "ホームページ制作・大規模改修",
        "独自システム・業務ツール開発",
        "外部サービスとの複雑な連携",
        "長時間または複数回の現地作業",
        "個別の社員研修を多数回実施する場合",
        "パソコン・ネットワーク機器の修理",
        "有料ツールやライセンスの利用料",
        "法律、税務、労務など専門資格が必要な判断",
      ],
    },
  },

  // 12. 料金
  pricing: {
    label: "PRICE",
    title: "導入する内容と範囲に応じてお見積りします",
    mainPlan: {
      name: "AI・デジタル導入支援",
      pricing: "100,000円〜",
      features: [
        "現状ヒアリング",
        "課題と導入目的の整理",
        "ツール選定",
        "基本的な初期設定",
        "利用ルール・テンプレート作成",
        "操作説明",
        "試行運用の確認",
      ],
    },
    note: "設定するサービス、対象人数、データ整理、研修、訪問回数などの範囲によって費用が変わります。",
    separateItems: [
      "大量のデータ移行",
      "多数のアカウント設定",
      "追加研修",
      "制作・システム開発",
      "継続的な運用支援",
    ],
    cta: "自社・自団体の場合の費用を相談する",
  },

  // 13. このサービスが向いている組織
  whoItIsFor: {
    label: "WHO IT IS FOR",
    title: "このような企業・団体に向いています",
    suitable: {
      title: "向いている組織",
      items: [
        "AIやデジタル導入の担当者がいない",
        "何を導入すべきか分からない",
        "小さな範囲から試したい",
        "初期設定やルール作成も支援してほしい",
        "社員やメンバーへの説明が必要",
        "導入後に使われなくなることを避けたい",
        "月額契約の前に、まず一つの課題を改善したい",
      ],
    },
    unsuitable: {
      title: "別のサービスが適している可能性がある組織",
      items: [
        "会社全体の改善を継続的に進めたい",
        "事務局業務を年間を通じて支援してほしい",
        "独自システムの開発だけを依頼したい",
        "大量の入力・移行作業だけを依頼したい",
      ],
    },
  },

  // 14. 他サービスとの違い
  serviceGuide: {
    label: "SERVICE GUIDE",
    title: "支援したい内容に応じて、サービスをお選びいただけます",
    services: [
      {
        name: "AI・デジタル導入支援",
        tagline: "特定の導入テーマを、使い始められる状態まで整える",
        type: "スポット・プロジェクト型",
        points: [
          "ツール選定",
          "初期設定",
          "ルール作成",
          "研修・試行運用",
        ],
        isCurrent: true,
      },
      {
        name: "DX顧問",
        tagline: "会社全体の業務改善を、継続して進める",
        type: "月額伴走型",
        points: [
          "課題整理",
          "改善の優先順位",
          "継続的な相談",
          "導入後の改善",
        ],
        isCurrent: false,
      },
      {
        name: "伴走型AI事務局サポート",
        tagline: "団体・会員組織の事務局運営を、年間を通じて支える",
        type: "月額伴走型",
        points: [
          "年間予定",
          "会員管理",
          "会議・広報",
          "引き継ぎ・運用改善",
        ],
        isCurrent: false,
      },
    ],
    note: "どのサービスが適しているか分からない場合は、ご相談内容を伺ったうえでご案内します。",
  },

  // 15. よくある質問
  faq: {
    label: "FAQ",
    title: "よくある質問",
    items: [
      {
        q: "何を導入するか決まっていなくても相談できますか",
        a: "はい。現在の業務と困りごとを確認し、導入が必要かどうかを含めて整理します。",
      },
      {
        q: "特定のAIサービスを勧められるのでしょうか",
        a: "特定のサービスを前提にはしません。目的、費用、安全性、現在の環境を確認して選定します。",
      },
      {
        q: "Google Workspaceの契約や設定もお願いできますか",
        a: "はい。プランの検討、アカウントや共有環境の整理、基本設定、操作説明まで対応します。",
      },
      {
        q: "社員向けのAI研修だけでも依頼できますか",
        a: "可能です。ただし、実際の業務内容を確認したうえで、一般的な機能説明だけでなく、業務に合った内容をご提案します。",
      },
      {
        q: "AIへ入力する情報の安全性も相談できますか",
        a: "はい。利用するサービスや契約内容を確認し、個人情報や機密情報の扱い、入力してよい情報の範囲を整理します。",
      },
      {
        q: "初期設定後も相談できますか",
        a: "導入後の継続支援は、DX顧問または伴走型AI事務局サポートとして対応できます。",
      },
      {
        q: "ホームページ制作やシステム開発も依頼できますか",
        a: "はい。株式会社ノーブルウェブのウェブ制作事業部や、業務ツール・システム開発サービスと連携します。",
      },
      {
        q: "パソコンの設定や修理もお願いできますか",
        a: "導入に必要なアカウントや基本設定は対応しますが、機器修理や一般的なパソコンサポートは対象外となる場合があります。",
      },
    ],
  },

  // 16. 関連サービス
  relatedServices: {
    label: "RELATED SERVICES",
    title: "導入後の改善や制作も、続けて相談できます",
    items: [
      {
        title: "DX顧問",
        desc: "会社全体のDXや業務改善を、月額で継続して支援します。",
        href: "/service/dx-consultant",
        icon: "ri-user-star-line",
      },
      {
        title: "伴走型AI事務局サポート",
        desc: "団体や会員組織の事務局運営を、年間予定に合わせて支援します。",
        href: "/service/ai-office",
        icon: "ri-team-line",
      },
      {
        title: "業務ツール・システム開発",
        desc: "既存ツールでは解決できない場合に、必要な業務ツールを開発します。",
        href: "/service/business-tool",
        icon: "ri-terminal-box-line",
      },
    ],
  },

  // 17. お問い合わせ
  cta: {
    label: "CONTACT",
    heading: "AIやデジタルを、何から始めるべきか一緒に考えませんか",
    description:
      "導入したいサービスが決まっていなくても問題ありません。現在の業務や困りごとを伺い、導入が必要かどうかを含めて整理します。",
    note: "特定のツール販売を前提とせず、無理なシステム導入を前提としたご提案は行いません。",
    beforeFormPoints: [
      "何も決まっていない段階でも相談可能",
      "特定のツール販売を前提にしない",
      "初期設定・ルール・研修まで対応",
      "オンライン・訪問対応",
    ],
    inquiryTypes: [
      "AI・デジタル導入について",
      "DX顧問について",
      "伴走型AI事務局サポートについて",
      "業務ツール・システム開発について",
      "セミナー・講演について",
      "その他",
    ],
  },
};